export const US_STATES = [
  { code: "AL", name_en: "Alabama", name_ar: "ألاباما" },
  { code: "AK", name_en: "Alaska", name_ar: "ألاسكا" },
  { code: "AZ", name_en: "Arizona", name_ar: "أريزونا" },
  { code: "AR", name_en: "Arkansas", name_ar: "أركنساس" },
  { code: "CA", name_en: "California", name_ar: "كاليفورنيا" },
  { code: "CO", name_en: "Colorado", name_ar: "كولورادو" },
  { code: "CT", name_en: "Connecticut", name_ar: "كونيتيكت" },
  { code: "DE", name_en: "Delaware", name_ar: "ديلاوير" },
  { code: "FL", name_en: "Florida", name_ar: "فلوريدا" },
  { code: "GA", name_en: "Georgia", name_ar: "جورجيا" },
  { code: "HI", name_en: "Hawaii", name_ar: "هاواي" },
  { code: "ID", name_en: "Idaho", name_ar: "أيداهو" },
  { code: "IL", name_en: "Illinois", name_ar: "إلينوي" },
  { code: "IN", name_en: "Indiana", name_ar: "إنديانا" },
  { code: "IA", name_en: "Iowa", name_ar: "أيوا" },
  { code: "KS", name_en: "Kansas", name_ar: "كانساس" },
  { code: "KY", name_en: "Kentucky", name_ar: "كنتاكي" },
  { code: "LA", name_en: "Louisiana", name_ar: "لويزيانا" },
  { code: "ME", name_en: "Maine", name_ar: "مين" },
  { code: "MD", name_en: "Maryland", name_ar: "ميريلاند" },
  { code: "MA", name_en: "Massachusetts", name_ar: "ماساتشوستس" },
  { code: "MI", name_en: "Michigan", name_ar: "ميشيغان" },
  { code: "MN", name_en: "Minnesota", name_ar: "مينيسوتا" },
  { code: "MS", name_en: "Mississippi", name_ar: "ميسيسيبي" },
  { code: "MO", name_en: "Missouri", name_ar: "ميزوري" },
  { code: "MT", name_en: "Montana", name_ar: "مونتانا" },
  { code: "NE", name_en: "Nebraska", name_ar: "نبراسكا" },
  { code: "NV", name_en: "Nevada", name_ar: "نيفادا" },
  { code: "NH", name_en: "New Hampshire", name_ar: "نيو هامبشير" },
  { code: "NJ", name_en: "New Jersey", name_ar: "نيوجيرسي" },
  { code: "NM", name_en: "New Mexico", name_ar: "نيومكسيكو" },
  { code: "NY", name_en: "New York", name_ar: "نيويورك" },
  { code: "NC", name_en: "North Carolina", name_ar: "نورث كارولاينا" },
  { code: "ND", name_en: "North Dakota", name_ar: "نورث داكوتا" },
  { code: "OH", name_en: "Ohio", name_ar: "أوهايو" },
  { code: "OK", name_en: "Oklahoma", name_ar: "أوكلاهوما" },
  { code: "OR", name_en: "Oregon", name_ar: "أوريغون" },
  { code: "PA", name_en: "Pennsylvania", name_ar: "بنسلفانيا" },
  { code: "RI", name_en: "Rhode Island", name_ar: "رود آيلاند" },
  { code: "SC", name_en: "South Carolina", name_ar: "ساوث كارولاينا" },
  { code: "SD", name_en: "South Dakota", name_ar: "ساوث داكوتا" },
  { code: "TN", name_en: "Tennessee", name_ar: "تينيسي" },
  { code: "TX", name_en: "Texas", name_ar: "تكساس" },
  { code: "UT", name_en: "Utah", name_ar: "يوتا" },
  { code: "VT", name_en: "Vermont", name_ar: "فيرمونت" },
  { code: "VA", name_en: "Virginia", name_ar: "فيرجينيا" },
  { code: "WA", name_en: "Washington", name_ar: "واشنطن" },
  { code: "WV", name_en: "West Virginia", name_ar: "ويست فيرجينيا" },
  { code: "WI", name_en: "Wisconsin", name_ar: "ويسكونسن" },
  { code: "WY", name_en: "Wyoming", name_ar: "وايومنغ" }
];

export const PROPERTY_TYPES = [
  { value: "apartment", label_ar: "شقة", label_en: "Apartment" },
  { value: "room", label_ar: "غرفة", label_en: "Room" },
  { value: "house", label_ar: "منزل", label_en: "House" },
  { value: "shop", label_ar: "محل تجاري", label_en: "Shop" },
  { value: "office", label_ar: "مكتب", label_en: "Office" }
];

export const VEHICLE_BRANDS = [
  "Toyota", "Honda", "Ford", "Chevrolet", "Nissan", "Hyundai", "Kia",
  "Mercedes-Benz", "BMW", "Audi", "Volkswagen", "Lexus", "Mazda", "Subaru",
  "Jeep", "Dodge", "Tesla", "Cadillac", "GMC", "Buick", "Acura", "Infiniti",
  "Volvo", "Porsche", "Land Rover", "Mitsubishi", "Other"
];

export const TRANSMISSIONS = [
  { value: "automatic", label_ar: "أوتوماتيك", label_en: "Automatic" },
  { value: "manual", label_ar: "عادي", label_en: "Manual" }
];

export const FUEL_TYPES = [
  { value: "gasoline", label_ar: "بنزين", label_en: "Gasoline" },
  { value: "diesel", label_ar: "ديزل", label_en: "Diesel" },
  { value: "electric", label_ar: "كهربائي", label_en: "Electric" },
  { value: "hybrid", label_ar: "هجين", label_en: "Hybrid" }
];

export const CONDITIONS = [
  { value: "new", label_ar: "جديدة", label_en: "New" },
  { value: "used", label_ar: "مستعملة", label_en: "Used" }
];
